import DatasetParseErrorContent from "./DatasetParseErrorContent";
import type { GenericErrorWithSuggestionResponse } from "@globals";
import Icon from "@lib/common/components/Icon/Icon";
import { Alert } from "@mantine/core";

export default function DatasetParseErrorAlert({
  error,
  title = "An error occurred while reading your file"
}: {
  error: GenericErrorWithSuggestionResponse;
  title?: string;
}) {
  return (
    <Alert color="red" variant="light" icon={<Icon name="circle-exclamation" />} title={title}>
      <DatasetParseErrorContent error={error} />
    </Alert>
  );
}
